import Box from '@mui/material/Box';
import { Location } from '@reach/router';
import { navigate } from 'gatsby';
import React, { useEffect, useRef, useState } from 'react';

import Fluid from 'components/Fluid';
import zparse from 'utils/zparse';

const canAccessIframe = function (iframe) {
	var html = null;
	try {
		// deal with older browsers
		var doc = iframe.contentDocument || iframe.contentWindow.document;
		html = doc.body.innerHTML;
	} catch (err) {
		// do nothing
	}

	return (html !== null);
}

const adjustFrameHeight = (iframe) => {
	iframe.style.height = `${iframe.contentDocument.body.scrollHeight}px`;
}

const SimpleviewForm = props => {
	const { formID, hijackSubmission, submissionRedirect, submissionMessage } = props;
	const iframeRef = useRef(null);
	const [formSubmitted, setFormSubmitted] = useState(false);
	const [hasIframeBeenFocused, setHasIframeBeenFocused] = useState(false);

	const handleIframeFocus = () => {
		if (!hasIframeBeenFocused) {
			setHasIframeBeenFocused(true);
		}
	};

	const handleMessages = (evt) => {
		if (evt.data.action === 'SimpleviewFormLoaded') {
			iframeRef.current.style.height = `${evt.data.height}px`;
		}
		if (evt.data.action === 'SimpleviewFormChanged') {
			iframeRef.current.style.height = `${evt.data.height}px`;
			iframeRef.current.style.visibility = 'visible';
		}
		if (evt.data.action === 'SimpleviewFormFocused') {
			setHasIframeBeenFocused(true);
			adjustFrameHeight(iframeRef.current);
		}
	}

	const handleIframeLoad = (evt) => {
		// grab all style elements and stylesheets from parent document head and inject into iframe head
		if (!iframeRef.current)return;
		const iframe = iframeRef.current;
		if (canAccessIframe(iframe) && iframe.contentDocument.body.querySelector('form') !== null) {
			const parentHead = document.head;
			const iframeHead = iframe.contentDocument.head;
			const parentStyles = parentHead.querySelectorAll('style');
			const parentSheets = parentHead.querySelectorAll('link[rel="stylesheet"]');
			parentStyles.forEach(style => {
				iframeHead.appendChild(style.cloneNode(true));
			});
			parentSheets.forEach(sheet => {
				iframeHead.appendChild(sheet.cloneNode(true));
			});
			adjustFrameHeight(iframe);
			setTimeout(() => {
				adjustFrameHeight(iframe);
				iframe.style.visibility = 'visible';
			}, 150)
		} else if (canAccessIframe(iframe) && hasIframeBeenFocused) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'simpleviewform',
				formid: formID,
			});
			setFormSubmitted(true);
			if (submissionRedirect) navigate(submissionRedirect);
		} else {
			// Something probably went wrong and we just need to try to display the form
			iframe.style.visibility = 'visibility';
		}
	}

	useEffect(() => {
		window.addEventListener('message', handleMessages);
		const iframe = iframeRef.current;
		if (iframe) {
			iframe.addEventListener('focus', handleIframeFocus);
			iframe.addEventListener('load', handleIframeLoad);
			return () => {
				iframe.removeEventListener('focus', handleIframeFocus);
				iframe.removeEventListener('load', handleIframeLoad);
				window.removeEventListener('message', handleMessages);
			};
		}
	});

	return (
		<Fluid layout="10" justifyContent="center">
			<Box>
				{((formSubmitted && !hijackSubmission) || !formSubmitted) && <iframe
					title={"SimpleView Embedded Form"}
					style={{ width: '100%', height: '100vh', border: 'none', visibility: 'hidden' }}
					src={`/api/simpleview/form/getRendered/?formID=${formID}&hijackSubmission=${hijackSubmission}`}
					ref={iframeRef}
				/>}
				{formSubmitted && <Box>{submissionMessage && zparse(submissionMessage)}</Box>}
			</Box>
		</Fluid>
	);
}

const SimpleviewFormComponent = props => {
	return (
		<Location>
			{locationProps => <SimpleviewForm {...props} location={locationProps.location} />}
		</Location>
	)
}

export default React.memo(SimpleviewFormComponent);
